import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { RouteResolverService } from './route-resolver.service';

/**
 * Guard that redirects to the first available route based on user permissions
 */
export const redirectToFirstAvailableRoute: CanActivateFn = () => {
  const router = inject(Router);
  const routeResolver = inject(RouteResolverService);

  const fallbackRoute = routeResolver.getFirstAvailableRoute();

  if (fallbackRoute) {
    return router.navigateByUrl(fallbackRoute);
  }

  // If no permissions at all, return false to prevent navigation
  console.error('User has no permissions to access any route');
  return false;
};
